var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "view",
          rawName: "v-view",
          value: _vm.isInView,
          expression: "isInView",
        },
      ],
      ref: "tile",
      staticClass: "rb-product-tile__wrapper",
      class: {
        "rb-product-tile--exclusive": _vm.isPlpExclusive,
        "rb-product-tile--editorial": _vm.isEditorial,
        "rb-product-tile-loading": _vm.loading,
      },
      attrs: {
        href: _vm.selectedVariant.url,
        "data-element-id": _vm.dataElementId,
        "data-description": _vm.dataDescriptionLabel,
        "aria-label": _vm.selectedVariant.name,
      },
      on: { click: _vm.onClick, focus: _vm.onFocus },
    },
    [
      _vm.isPlpExclusive && !_vm.loading
        ? _c("rb-lazy-media", {
            ref: "wornExclusive",
            staticClass: "rb-product-tile-exclusive__worn-image",
            attrs: { src: _vm.wornImage },
          })
        : _vm.loading
        ? _c("rb-dummy-skeleton", {
            staticClass: "rb-product-tile-exclusive__worn-image --worn-image",
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rb-product-tile",
          class: [
            {
              "rb-product-tile--loading": _vm.loading,
              "rb-product-tile--hover": _vm.canAddHoverClass,
              "rb-has-worn": _vm.isWornVariant,
            },
            _vm.getWornImagePosition
              ? "rb-has-worn-position-" + _vm.getWornImagePosition
              : "",
          ],
          attrs: {
            "data-mnt-product-upc": _vm.upc,
            "data-mnt-product-customizable": _vm.isCustomizable,
            "data-mnt-product-sku": _vm.sku,
          },
        },
        [
          _c(
            "div",
            {
              ref: "clickArea",
              staticClass: "rb-product-tile__area",
              class: { "--no-colors": _vm.colors.length === 1 },
            },
            [
              _c("rb-product-tile-header", {
                attrs: {
                  "selected-variant": _vm.selectedVariant,
                  "current-promotion": _vm.currentPromotion,
                  "wishlist-icon-is-visible": _vm.wishlistIconIsVisible,
                },
              }),
              _vm._v(" "),
              _c("rb-product-tile-images-content", {
                attrs: {
                  colors: _vm.colors,
                  "worn-image": _vm.wornImage,
                  "show-hover-image": _vm.showHoverImage,
                  "selected-index": _vm.selectedIndex,
                  "worn-image-position": _vm.getWornImagePosition,
                  "prevent-lazy": _vm.preventLazy,
                  "first-hover": _vm.firstHover,
                  "is-first-transition-in-viewport":
                    _vm.isFirstTransitionInViewport,
                  "is-inside-search-panel": _vm.isInsideSearchPanel,
                },
                on: { "update:select-index": _vm.selectIndex },
              }),
              _vm._v(" "),
              _c("rb-product-tile-content", {
                attrs: {
                  "selected-variant": _vm.selectedVariant,
                  "current-promotion": _vm.currentPromotion,
                },
              }),
              _vm._v(" "),
              _c("rb-product-tile-footer", {
                attrs: {
                  "selected-variant": _vm.selectedVariant,
                  colors: _vm.colors,
                  "selected-index": _vm.selectedIndex,
                  "is-add-to-cart": _vm.addToCartAvailable,
                },
                on: { "action:add-to-bag": _vm.addToBag },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.firstHover || _vm.showBottomCarousel
            ? _c("rb-product-tile-bottom-carousel", {
                attrs: {
                  "selected-index": _vm.selectedIndex,
                  colors: _vm.colors,
                  category: _vm.category,
                  hover: _vm.showBottomCarousel,
                  "first-hover": _vm.firstHover,
                  "selected-variant": _vm.selectedVariant,
                  "is-add-to-cart": _vm.addToCartAvailable,
                },
                on: { "update:select-index": _vm.selectIndex },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }